import { useRef, useEffect } from "react";
export var useIsMounted = function useIsMounted() {
  var isMountedRef = useRef(!1);
  return useEffect(function () {
    return isMountedRef.current = !0, function () {
      isMountedRef.current = !1;
    };
  }, []), isMountedRef;
};